module.exports = [
	{
		quote: "If you lose, don't lose the lesson.",
		author: "Dalai Lama",
	},
	{
		quote: "They’re naysayers because they can’t do it, not because they don’t think you can do it.",
		author: "Ayodeji Awosika",
	},
	{
		quote: "Even the Mona Lisa started out as a portrait of Lisa del Giocondo.",
		author: "Daniel Bourke",
	},
	{
		quote: "Don't attempt to apply math where it isn’t applicable.",
		author: "Lucyna Kushinada",
	},
];
